import { getFrequencyLabel } from "library/get-frequency-label.mjs"

export function createCompareAuditTask(task, allSkills) {
    const skill = allSkills[task.skillSet]
    return {
        classification: task.classification,
        frequency: getFrequencyLabel(task.frequency),
        minutes: task.minutes,
        included: task.included,
        skill: skill ? { Skilling: skill.Skilling, SkillingCode: skill.SkillingCode } : undefined,
    }
}
